<ng-container *ngIf="!loading; else isLoading">
  <div class="form-group gw-relative">
    <div class="gw-flex gw-flex-col">
      <label class="gw-form-label" *ngIf="label">
        {{ label }}
        <span *ngIf="required" class="gw-text-status-negative">*</span>
      </label>

      <div class="gw-relative">
        <tui-textfield
          multi
          tuiChevron
          tuiTextfieldSize="m"
          class="gatewee-multi-textfield gw-w-full"
          [iconStart]="iconStart"
          [stringify]="stringify"
          [identityMatcher]="identityMatcher"
          [tuiTextfieldCleaner]="false"
        >
          <input
            tuiInputChip
            tuiSelectLike
            class="multi-select-picker"
            [placeholder]="value.length ? '' : placeholder"
            [disabled]="disabled"
            [ngModel]="value"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onValueChange($event)"
            (mousedown)="onInputMouseDown($event)"
          />

          <tui-data-list-wrapper
            *tuiTextfieldDropdown
            new
            [items]="dropdownItems"
            [itemContent]="itemContentTpl"
            [emptyContent]="emptyStateText"
          />

          <ng-template #itemContentTpl let-option>
            <span
              class="multi-select-option gw-flex gw-items-center gw-gap-2 gw-w-full"
            >
              <input
                tuiCheckbox
                type="checkbox"
                [checked]="isSelected(option)"
                [size]="'s'"
                class="gw-pointer-events-none gw-shrink-0"
                tabindex="-1"
              />
              <span class="gw-flex-1 gw-text-left">{{ option.label }}</span>
            </span>
          </ng-template>

          <button
            *ngIf="value.length > 0 && !disabled"
            type="button"
            class="gw-absolute gw-right-10 gw-top-1/2 gw-z-10 gw-flex gw-h-8 gw-w-8 gw--translate-y-1/2 gw-items-center gw-justify-center gw-rounded-md gw-text-text-secondary gw-transition-colors hover:gw-text-text-primary"
            (mousedown)="$event.preventDefault()"
            (click)="clearValue()"
          >
            <i class="fa-solid fa-x gw-text-[12px]"></i>
          </button>

          <tui-icon *ngIf="toolTip" [tuiTooltip]="toolTip" />
        </tui-textfield>
      </div>
    </div>

    <error-message *ngIf="control" [control]="control"></error-message>
  </div>
</ng-container>

<ng-template #isLoading>
  <gatewee-skeleton></gatewee-skeleton>
</ng-template>
